import type { BettingInformation } from '../../../Model/BettingInformation'
import type { IObservableStarter } from '../../../Model/Observables/IObservableStarter'
import { CheckBoxSelection } from '../UIElements/CheckboxSelection'
import { BaseCheckBoxSelectionProcessor } from './BaseCheckBoxSelectionProcessor'
import CheckBoxFieldProcessor from './CheckBoxFieldProcessor'
import CheckBoxPipelineService from './CheckBoxPipelineService'
import CheckBoxSameAsProcessor from './CheckBoxSameAsProcessor'
import type { ISelectionContext } from './ISelectionContext'

export default class CheckboxSelectionProcessor extends BaseCheckBoxSelectionProcessor {
  public constructor(count: number) {
    super(count)
  }

  public tag(): string {
    return 'CheckboxSelectionProcessor'
  }

  public generateSelections(
    starter: IObservableStarter,
    starters: ko.ObservableArray<IObservableStarter>,
    bettingContext: BettingInformation,
    context: ISelectionContext
  ): IObservableStarter[] {
    return CheckBoxPipelineService.process(starter, starters, bettingContext, context, this.count)
  }

  public processFieldSelection(
    starters: ko.ObservableArray<IObservableStarter>,
    selections: ko.ObservableArray<IObservableStarter>,
    bettingContext: BettingInformation,
    index: number,
    selected: boolean
  ) {
    const processor = new CheckBoxFieldProcessor()
    processor.process(starters, selections, bettingContext, index, selected)
  }

  public processSameAsSelection(
    starters: ko.ObservableArray<IObservableStarter>,
    selections: ko.ObservableArray<IObservableStarter>,
    bettingContext: BettingInformation,
    row: number,
    column: number,
    selected: boolean
  ) {
    const processor = new CheckBoxSameAsProcessor()
    processor.process(starters, selections, bettingContext, row, column, selected)
  }

  public clearAllSelections(
    starters: ko.ObservableArray<IObservableStarter>[],
    selections: ko.ObservableArray<IObservableStarter>[]
  ) {
    selections.forEach(starters => {
      starters().forEach(starter => (starter.selection() as CheckBoxSelection).clearAll())
    })
  }
}
